(function (angular) {
	angular.module('bizPartEngage').controller('core.forgotpassword', forgotpasswordController);
	angular.module('bizPartEngage').controller('core.changepassword', changepasswordController);

	forgotpasswordController.$inject = ["$rootScope", "core.forgotpasswordService", "$mdDialog", "$translate", "bizValidationService", "$mdToast", "bizCoreService"];
    changepasswordController.$inject = ["$rootScope", "core.forgotpasswordService", "$mdDialog", "$translate", "bizValidationService", "$mdToast", "$stateParams", "$state", "bizCoreService"];

	function forgotpasswordController($rootScope, forgotpasswordService, $mdDialog, $translate, bizValidationService, $mdToast, bizCoreService) {
		var vm = this;
		vm.IsIframed = false;
		vm.mode = 'requestpassword';
		vm.SendForgotPasswordWithEmail = SendForgotPasswordWithEmail;
		vm.Message = '';
        vm.ShowLogin = ShowLogin;
        vm.ErrorObject = null;
		vm.Portal;

		vm.BackgroundImage = 'Images/login-img.png';
		vm.IsImagesInitialized = false;

		vm.User = {
			Email: ''
		};

		function ShowLogin() {
			$rootScope.$broadcast('SHOW-LOGIN-DIRECTIVE');
		}

		function SendForgotPasswordWithEmail() {
			vm.Message = '';
			if (vm.User.Email && vm.User.Email.indexOf('@') > 0) { // bizValidationService.FormValid(vm.MyForm1) == true && 

				forgotpasswordService.SendPasswordRecoveryEmail(vm.User.Email).then(forgotpasswordSuccess);

				function forgotpasswordSuccess(response) {
					if (response.data.Success == true) {
						vm.User.Email = '';
						$translate('CORE.FORGOTPASSWORD.EMAILSENT').then(function(translation) {
							vm.Message = translation || 'E-mail sent!';
						});
					}
					else if (response.data.Message.length > 0) {
						vm.Message = response.data.Message;
                    }

                    vm.ErrorObject = response.data.Object;
				}
			}
			else {
				
				$translate('CORE.FORGOTPASSWORD.NOVALIDEMAILSUPPLIED').then(function (translation) {
					vm.Message = translation || 'No valid email was supplied';
				});
			}
		}

		function GetInitData() {
			forgotpasswordService.GetBackgroundImage().then(function (response) {
				if (response.length > 0)
					vm.BackgroundImage = response;

				vm.IsImagesInitialized = true;
			});

			$rootScope.HasAcceptedCookies = getLocalStorage('HasAcceptedCookies');
        }

		function Init() {
			if (window.location.search.indexOf('framed') > -1) {
				vm.IsIframed = true;
			}

			GetInitData();
		}

		vm.$onInit = Init;
	}

    function changepasswordController($rootScope, forgotpasswordService, $mdDialog, $translate, bizValidationService, $mdToast, $stateParams, $state, bizCoreService) {
		var vm = this;
		vm.Guid = $stateParams.guid;
		vm.mode = 'changepassword';
		vm.PasswordWasUpdated = false;
		vm.IsGuidValid = false;

		vm.BackgroundImage = 'Images/login-img.png';
		vm.IsImagesInitialized = false;

		vm.UpdatePassword = UpdatePassword;
		vm.Init = Init;

        function Init() {
            GetInitData();

			forgotpasswordService.IsResetPasswordGuidValid(vm.Guid).then(IsResetPasswordGuidValidSuccess);

			function IsResetPasswordGuidValidSuccess(response) {
				vm.IsGuidValid = response.data.Success;

				if (vm.IsGuidValid == false) {
					$translate('CORE.FORGOTPASSWORD.GUIDNOTVALID').then(function (translation) {
						vm.Message = translation || 'Supplied link is not valid!';
					});
				}
			}
        }

        function GetInitData() {
			forgotpasswordService.GetBackgroundImage().then(function (response) {
				if (response.length > 0)
					vm.BackgroundImage = response;

				vm.IsImagesInitialized = true;
			});
        }
		
		function UpdatePassword() {
			if (!vm.MyForm2.$valid || vm.Password != vm.RepeatPassword) {

				return;
			}

			//if (bizValidationService.FormValid(vm.MyForm2) == true) { // TODO more validation, regex...?

				//vm.Password = vm.Password.trim();
				//vm.RepeatPassword = vm.RepeatPassword.trim();

				//if (vm.Password != vm.RepeatPassword) {
				//	$translate('CORE.FORGOTPASSWORD.PASSWORDNOTSAME').then(function (translation) {
				//		vm.Message = translation || 'Passwords does not match!';
				//	});
				//}
				//else {
					forgotpasswordService.UpdatePassword(vm.Guid, vm.Password).then(updateSuccess);

					function updateSuccess(response) {
						if (response.data.Success == true) {
							$translate('CORE.FORGOTPASSWORD.RESETSUCCESS').then(function (translation) {
								vm.Message = translation || 'Password updated!';
							});

							vm.PasswordWasUpdated = true;
							vm.Password = '';
                            vm.RepeatPassword = '';
						}
						else {
							vm.Message = response.data.Message;
						}
					}
				//}
			//}
			
		}

		vm.$onInit = vm.Init;
	}
})(window.angular);
